/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import ProspectingListCard from './ProspectingListCard'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'

function ProspectingListPage () {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'prospecting.plural',
    defaultMessage: 'Prospections'
  })

  const [searchParams, setSearchParams] = useQueryParams()
  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <ProspectingListCard
          query={searchParams}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default ProspectingListPage
